import Flex from "@/components/Flex/Flex";
import { ProductResearchSearchResultsTable } from "../ProductResearchSearchResultsTable/ProductResearchSearchResultsTable";

import styles from "./ProductResearchPage.module.css";


export function ProductResearchPage() {
  return (
    <Flex direction="column" className={styles.page} gap={2}>
      <ProductResearchSearchResultsTable/>
    </Flex>
  );
}
